import { render } from "./ImageLoader.vue?vue&type=template&id=37cd3a2f"
import script from "./ImageLoader.vue?vue&type=script&lang=ts"
export * from "./ImageLoader.vue?vue&type=script&lang=ts"

import "./ImageLoader.vue?vue&type=style&index=0&id=37cd3a2f&lang=css"
script.render = render

export default script